import React from 'react'
import styled from 'styled-components'

const BG = styled.div`
  margin-bottom: 0.5rem;
`

const DisplayFieldLabel = styled.label`
  color: ${props => props.theme.colors.gray600};
  font-size: 0.88rem;
`
const DisplayFieldValue = styled.div`
  color: ${props => props.theme.colors.black};
  font-size: 1rem;

  a {
    cursor: pointer;
    font-weight: 600;
    color: ${props => props.theme.colors.interactive};
    &:hover {
      color: ${props => props.theme.colors.interactive};
    }
  }
`

const DisplayField = ({ id, label, value, action, ...rest }) => {
  const appliedID = id || `display-field-${label}`

  return (
    <BG {...rest}>
      <DisplayFieldLabel htmlFor={appliedID}>{label}</DisplayFieldLabel>
      <DisplayFieldValue id={appliedID}>
        {value}
        {action && (
          <>
            <br />
            <span>
              {'  '}
              <a>{action}</a>
            </span>
          </>
        )}
      </DisplayFieldValue>
    </BG>
  )
}

export default DisplayField
